<script setup lang="ts">
import { type PartType } from '@/types/rc/miners/PartType'
import { ref } from 'vue'
import SparePartSelect from '../spare-parts/SparePartSelect.vue'
import type { ISparePart } from '@/types/rc/spare-parts'

const props = defineProps<{
  partType: PartType
  customerId: number
  title: string
  dialogText: string
}>()

const open = defineModel<boolean>()
const emit = defineEmits(['close', 'sparePartSelected'])

const isLoading = ref<boolean>(false)
const selectedSparePart = ref<ISparePart>()

/**
 * Handles form submit.
 *
 * @param formEl form element ref.
 */
const submit = async () => {
  isLoading.value = true
  emit('sparePartSelected', selectedSparePart.value?.id)
}

/**
 * Reset form, reset mutations, emit closed.
 */
const handleClosed = () => {
  isLoading.value = false
  selectedSparePart.value = undefined
  emit('close')
}
</script>

<template>
  <el-dialog
    v-model="open"
    :width="600"
    :title="props.title"
    :show-close="false"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <p>{{ props.dialogText }}</p>
    <br />
    <SparePartSelect v-model="selectedSparePart" :part-type="props.partType" :customer-id="props.customerId" />
    <template #footer>
      <el-button :disabled="isLoading" @click="open = false">Cancel</el-button>
      <el-button type="primary" :loading="isLoading" :disabled="!selectedSparePart" @click="submit()">Submit</el-button>
    </template>
  </el-dialog>
</template>

<style scoped lang="scss">
.scrollable-list {
  max-height: 132px;
  overflow-y: auto;
}

ul {
  list-style-type: disc;
  list-style-position: inside;
}
</style>
